<nav #nav="ngbNav" class="nav-tabs" ngbNav>

  @if (isCurrentReportsTabSelected) {
    <div class="nav-tabs-time d-none d-lg-flex align-self-center align-items-center">
      <i class="fa-solid fa-filter mr-1 text-muted"></i>
      <strong class="mr-1" translate> Last update:</strong>
      <span [innerText]="lastUpdateTimestamp|date:'HH:mm:ss'"></span>
    </div>
  }

  <ng-container ngbNavItem>
    <a (click)="onCurrentReportsSelectedChange(true)"
    ngbNavLink translate>Current Reports</a>
    <ng-template ngbNavContent>
      @if (!liveDataStreamingEnabled) {
        <div
          class="alert alert-info text-center">
          <span translate>Live data streaming is disabled. No data is polled.</span>
        </div>
      }
      <div class="table-responsive-md">
        <table class="table vertical-align-middle mb-0">
          <thead>
            <tr>
              <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="sortableType">
                <span translate>Type</span>
              </th>

              <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="signalName">
                <span translate>Signal</span>
              </th>
              <th (sort)="onColumnSort($event)" class="sortable" scope="col" sortable="code">
                <span>Value / BIT</span>
              </th>
              <th (sort)="onColumnSort($event)" class="d-none d-md-table-cell sortable" scope="col"
                sortable="description">
                <span translate>Description</span>
              </th>
              <th (sort)="onColumnSort($event)" class="d-none d-md-table-cell sortable" scope="col" sortable="timestamp">
                <span translate>Timestamp</span>
              </th>
              <th class="td-expand"></th>
            </tr>
          </thead>
          <tbody>
            @for (item of statusEventsCurrent; track item) {
              <scitis-status-event-row
                [eventDetails]="item"
                class="d-contents">
              </scitis-status-event-row>
            }
          </tbody>
        </table>
      </div>
    </ng-template>
  </ng-container>
  <ng-container ngbNavItem>
    <a (click)="onCurrentReportsSelectedChange(false)" ngbNavLink translate>Past Reports</a>
    <ng-template ngbNavContent>

      <div class="form-row align-items-end">
        <div [ngClass]="showCustomDatePicker ? 'col-5' : 'col-9'" class="col">
          <div class="form-group" style="min-width: 280px;">
            <label>
              <span translate>Interval</span>:
              <span class="ml-1" [innerHTML]="shownInterval"></span>
            </label>
            <ng-select
              (change)="setTimeInterval($event)"
              [items]="timeIntervals"
              bindLabel="name"
              bindValue="id">
            </ng-select>
          </div>
        </div>
        @if (showCustomDatePicker) {
          <div class="col-2">
            <scitis-date-time-picker
              (focusOut)="onFocusOutStartTime($event)"
              [showRequiredFieldIndicator]="false"
              [useMaxDate]="true"
              [showSeconds]="false"
              [startDate]="getStartDate()"
              [startTime]="getStartTime()"
              [textLabel]="startTimeLabel">
            </scitis-date-time-picker>
          </div>
        }
        @if (showCustomDatePicker) {
          <div class="col-2">
            <scitis-date-time-picker
              (focusOut)="onFocusOutEndTime($event)"
              [showRequiredFieldIndicator]="false"
              [useMaxDate]="true"
              [showSeconds]="false"
              [startDate]="getStartDate()"
              [startTime]="getStartTime()"
              [textLabel]="endTimeLabel">
            </scitis-date-time-picker>
          </div>
        }

        <div class="col-3">
          <button
            [disabled]="isLoadingPastData"
            (click)="update()"
            [title]="'Apply' | translate"
            class="btn btn-primary btn-block mb-3">
            <span class="fa-solid fa-arrows-rotate"></span>
            <span [innerHTML]="'Update' | translate"></span>
          </button>
        </div>
      </div>

      <div class="table-responsive-md">
        <table class="table vertical-align-middle mb-0">
          <thead>
            <tr>
              <th (sort)="onColumnSortPastData($event)" class="sortable" scope="col" sortable="type">
                <span translate>Type</span>
              </th>

              <th (sort)="onColumnSortPastData($event)" class="sortable" scope="col" sortable="signalName">
                <span translate>Signal</span>
              </th>
              <th (sort)="onColumnSortPastData($event)" class="sortable" scope="col" sortable="code">
                <span translate>Value / BIT</span>
              </th>
              <th class="d-none d-md-table-cell">
                <span translate>Description</span>
              </th>
              <th (sort)="onColumnSortPastData($event)" class="d-none d-md-table-cell sortable" scope="col"
                sortable="timestamp">
                <span translate>Timestamp</span>
              </th>
              <th class="td-expand"></th>
            </tr>
          </thead>
          <tbody>
            @for (item of statusEventsPast; track item) {
              <scitis-status-event-row
                [eventDetails]="item"
                class="d-contents">
              </scitis-status-event-row>
            }
          </tbody>
        </table>
      </div>

      @if (!statusEventsPast || statusEventsPast.length === 0) {
        <div
          class="d-flex align-items-center justify-content-center w-100 mb-0 alert alert-info text-center"
          style="height: 500px">
          <div>
            <span class="fa-solid fa-circle-info mr-2"></span>
            <span translate>No Data available. Please check the configuration.</span>
          </div>
        </div>
      }
    </ng-template>
  </ng-container>
</nav>

<div class="card card-table-view card-table-view-tabs-with-pagination mb-2">
  <div [ngbNavOutlet]="nav" class="card-body"></div>
</div>

@if (!isCurrentReportsTabSelected) {
  <scitis-pagination (itemsPerPageChanged)="onItemsPerPageChange($event)"
    (loadPageNumber)="onLoadPageNumber($event)"
    [disablePageNavigation]="isLoadingPastData"
    [lastPageReached]="lastPageReached"
    [reset]="resetPaginationPageIndex">
  </scitis-pagination>
}
